import { Helmet } from 'react-helmet-async'

const Seo = ({ title, description, content, index = true, canonicalUrl }) => {
  const canonical =
    canonicalUrl || window.location.origin + window.location.pathname

  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:type" content={content} />
      <link rel="canonical" href={canonical} />
      {!index && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  )
}

export default Seo
